import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const SkillSetMaster = React.lazy(() =>
  import("@/pages/careerProgression/masters/skillSetMaster")
);
const EmployeeCareerProgression = React.lazy(() =>
  import("@/pages/careerProgression/Employee/index")
);
const RMCareerProgression = React.lazy(() =>
  import("@/pages/careerProgression/ReportingManager/index")
);
const FunctionalHeadCareerProgression = React.lazy(() =>
  import("@/pages/careerProgression/FuntionalHead/index")
);
const HRCareerProgression = React.lazy(() =>
  import("@/pages/careerProgression/HR/index")
);
const ReportingManagerIDPCareerProgression = React.lazy(() =>
  import("@/pages/careerProgression/ReportingManager/IDPIndex")
);
const EmployeeIDPCareerProgression = React.lazy(() =>
  import("@/pages/careerProgression/Employee/IDPEmployeeIndex")
);
const CareerProgression = React.lazy(() =>
  import("@/pages/careerProgression/CareerProgression/CareerProgration")
);
const BHCareerProgression = React.lazy(() =>
  import("@/pages/careerProgression/BH/index")
);  

const careerProgression = [
  {
    path: "skillSetMaster",
    element: (
      <SuspenseWrapper>
        <SkillSetMaster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "employeeCareerProgression",
    element: (
      <SuspenseWrapper>
        <EmployeeCareerProgression />
      </SuspenseWrapper>
    ),
  },
  {
    path: "rmCareerProgression",
    element: (
      <SuspenseWrapper>
        <RMCareerProgression />
      </SuspenseWrapper>
    ),
  },
  {
    path: "functionalHeadCareerProgression",
    element: (
      <SuspenseWrapper>
        <FunctionalHeadCareerProgression />
      </SuspenseWrapper>
    ),
  },
  {
    path: "HRCareerProgression",
    element: (
      <SuspenseWrapper>
        <HRCareerProgression />
      </SuspenseWrapper>
    ),
  },
  {
    path: "reportingManagerIDP",
    element: (
      <SuspenseWrapper>
        <ReportingManagerIDPCareerProgression />
      </SuspenseWrapper>
    ),
  },
  {
    path: "employeeIDP",
    element: (
      <SuspenseWrapper>
        <EmployeeIDPCareerProgression />
      </SuspenseWrapper>
    ),
  },
  {
    path: "careerprogression",
    element: (
      <SuspenseWrapper>
        <CareerProgression />
      </SuspenseWrapper>
    ),
  },
  {
    path: "bhCareerProgression",
    element: (
      <SuspenseWrapper>
        <BHCareerProgression />
      </SuspenseWrapper>
    ),
  }
];

export default careerProgression;
